import React, {useEffect, useState} from 'react';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {getAnalysisModService, getAnalysisService} from "../../../services/app.service";
import {ANALYSIS_TYPES} from "../../../utils/constants";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

function Level7CoverageComp(props) {

    const {application_id, reload} = props;

    const [analysis, setAnalysis] = useState({});
    const [loading, setLoading] = useState(false);

    async function fetchAnalysis() {
        try {
            setLoading(true);
            const result = await getAnalysisService(application_id, ANALYSIS_TYPES.LEVEL_7_COVERAGE);
            if(!result.error) {
                setAnalysis(result.data);
                console.log(result.data);
            }
            setLoading(false);
        }
        catch (e) {
            console.error(e);
            // already toasted the error
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchAnalysis().then();
    }, [reload])

    return <>
        <br/>
            <Grid container spacing={2}>
                <Grid item>
                    <TextField id='assumption1' variant="outlined" label={'Minimum Coverage %'} value={analysis.assumption1 ? `${analysis.assumption1}%` : ""} InputProps={{readOnly: true}}/>
                </Grid>
                <Grid item>
                    <TextField id='assumption2' variant="outlined" label={'Minimum Count'} value={analysis.assumption2 || ""} InputProps={{readOnly: true}}/>
                </Grid>
            </Grid>
        <br/>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Level 8</TableCell>
                        <TableCell>Sum of Count</TableCell>
                        <TableCell>How many Level 9 within Level 8</TableCell>
                        <TableCell>Level 8 Coverage</TableCell>
                        <TableCell>Level 8 Covered or Not</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        analysis.data && analysis.data.map((item) =>
                           <TableRow>
                               <TableCell>{item.level8}</TableCell>
                               <TableCell>{item.count}</TableCell>
                               <TableCell>{item.total}</TableCell>
                               <TableCell>{item.coverage}%</TableCell>
                               <TableCell>{item.is_covered ? 'Yes' : 'No'}</TableCell>
                           </TableRow>
                        )
                    }
                    {
                        analysis.grand_total &&
                            <TableRow>
                                <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.level8}</TableCell>
                                <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.count}</TableCell>
                                <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.total}</TableCell>
                                <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.coverage}%</TableCell>
                                <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.is_covered ? 'Yes' : 'No'}</TableCell>
                            </TableRow>
                    }
                </TableBody>
            </Table>
            <LoaderWithBackDrop loading={loading}/>
        </TableContainer>
    </>
}

export default Level7CoverageComp;